var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-callai-team"},[_c('div',{staticClass:"title"},[_vm._v("我们的团队")]),_c('photoWall')],1)}
var staticRenderFns = []

export { render, staticRenderFns }